export default __webpack_public_path__ + "static/media/banner_desk_amarelo_2.e54303b6.jpg";